import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OuiButtonModule } from 'omnium-ui/button';
import { OuiDialogModule } from 'omnium-ui/dialog';
import { OuiIconModule } from 'omnium-ui/icon';
import { TechnicalInvestorPurgeExecution } from '../../../../core/models/api.models';

type DialogData = {
  execution: TechnicalInvestorPurgeExecution;
};

@Component({
  selector: 'dbw-technical-investor-purge-execution-details-dialog',
  imports: [OuiButtonModule, OuiDialogModule, OuiIconModule],
  templateUrl: './technical-investor-purge-execution-details-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './technical-investor-purge-execution-details-dialog.component.scss',
})
export class TechnicalInvestorPurgeExecutionDetailsDialogComponent {
  private readonly data = inject<DialogData>(MAT_DIALOG_DATA);

  protected readonly execution = this.data.execution;

  protected formatDate(value?: string | null): string {
    if (!value) {
      return 'Non renseigné';
    }

    return new Intl.DateTimeFormat('fr-FR', {
      dateStyle: 'short',
      timeStyle: 'medium',
    }).format(new Date(value));
  }
}
